import React, { useState } from "react";

import { TextField, Button, Box, Typography, Container } from "@mui/material";
import { useFormik } from "formik";
import debounce from "lodash.debounce";

import Autocomplete from "@mui/material/Autocomplete";

import { useAuth } from "../context/AuthProvider";
import { userFormSchema } from "../utils/validation";
import { axiosInstance } from "../service/axiosInstance";

import serviceEndpoints from "../services/serviceEndpoints";

const UserFormComponent = ({ setShowSuccess }) => {
  const { userDetail } = useAuth();

  const [reportingManagerOptions, setReportingManagerOptions] = useState([]);

  const fetchManagers = async (query) => {
    if (query.length < 2) return;

    try {
      const response = await axiosInstance.post(
        serviceEndpoints.fetchManagerList,
        {
          name: query,
        }
      );
      console.log("response", response.data.data);
      setReportingManagerOptions(response.data.data);
    } catch (error) {
      console.error("Error fetching managers:", error);
    }
  };

  const debouncedFetchManagers = debounce(fetchManagers, 300);

  const { handleSubmit, handleChange, touched, errors, values, setFieldValue } =
    useFormik({
      initialValues: {
        name: "",
        email: "",
        mobile: "",
        // password: "",
        userRole: "",
        channel: "",
        reportingManagerId: null,
        employeeId: "",
      },

      onSubmit: (values) => createUser(values),
      validationSchema: userFormSchema,
    });

  const createUser = async (values) => {
    console.log("values", values);
    try {
      await axiosInstance.post(serviceEndpoints.createUser, {
        ...values,
        reportingManagerId: values.reportingManagerId
          ? values.reportingManagerId.id
          : null,
      });
      setShowSuccess(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleUserRoleInputChange = (key) => (event, newValue) => {
    setFieldValue((prev) => ({ ...prev, [key]: newValue }));
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        marginTop: 4,
        marginBottom: 2,
        paddingBottom: "80px",
      }}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <Box
          className="border-box container_bg"
          sx={{
            alignItems: "center",
            borderRadius: "30px",
            padding: 2,
            // border: "1px solid #ddd",
            flexDirection: "row",
            marginBottom: 2,
          }}
        >
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Name <span className="mandatory_mark"> *</span>
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="name"
              value={values.name}
              label="Enter name"
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
              onChange={handleChange}
              inputProps={{ maxLength: 100 }}
            />
          </Box>
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Email <span className="mandatory_mark"> *</span>
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="email"
              value={values.email}
              label="Enter email"
              onChange={handleChange}
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && errors.email}
              inputProps={{ maxLength: 100 }}
            />
          </Box>
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Mobile <span className="mandatory_mark"> *</span>
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="mobile"
              type="number"
              value={values.mobile}
              label="Enter mobile"
              onChange={handleChange}
              error={touched.mobile && Boolean(errors.mobile)}
              helperText={touched.mobile && errors.mobile}
              inputProps={{ maxLength: 10 }}
            />
          </Box>
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Employee Id <span className="mandatory_mark"> *</span>
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="employeeId"
              value={values.employeeId}
              label="Enter employee Id"
              onChange={handleChange}
              error={touched.employeeId && Boolean(errors.employeeId)}
              helperText={touched.employeeId && errors.employeeId}
              inputProps={{ maxLength: 100 }}
            />
          </Box>
          {/* <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Password
            </Typography>
            <TextField
              fullWidth
              type="password"
              variant="outlined"
              name="password"
              value={values.password}
              onChange={handleChange}
              label="Enter password"
              error={touched.password && Boolean(errors.password)}
              helperText={touched.password && errors.password}
            />
          </Box> */}
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              User role <span className="mandatory_mark"> *</span>
            </Typography>
            <Autocomplete
              options={userDetail?.meta?.ALL_ROLES}
              onChange={(event, newValue) => {
                setFieldValue("userRole", newValue);
              }}
              name="imdName"
              value={values.userRole}
              onInputChange={handleUserRoleInputChange("userRole")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Enter user role"
                  // required={true}
                  error={touched.userRole && Boolean(errors.userRole)}
                  helperText={touched.userRole && errors.userRole}
                />
              )}
            />
          </Box>
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Channel <span className="mandatory_mark"> *</span>
            </Typography>
            <Autocomplete
              options={userDetail?.meta?.ALL_CHANNELS}
              onChange={(event, newValue) => {
                setFieldValue("channel", newValue);
              }}
              name="channel"
              value={values.channel}
              onInputChange={handleUserRoleInputChange("channel")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Enter channel"
                  // required={true}
                  error={touched.channel && Boolean(errors.channel)}
                  helperText={touched.channel && errors.channel}
                />
              )}
            />
          </Box>
          <Box sx={{ marginBottom: 2 }}>
            {" "}
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Reporting manager name <span className="mandatory_mark"> *</span>
            </Typography>
            <Autocomplete
              options={reportingManagerOptions}
              getOptionLabel={(option) => option.name}
              value={values.reportingManagerId}
              onInputChange={(event, newInputValue) => {
                debouncedFetchManagers(newInputValue);
              }}
              onChange={(event, newValue) => {
                setFieldValue("reportingManagerId", newValue || null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Enter Reporting Manager Name"
                  error={
                    touched.reportingManagerId &&
                    Boolean(errors.reportingManagerId)
                  }
                  helperText={
                    touched.reportingManagerId && errors.reportingManagerId
                  }
                />
              )}
            />
          </Box>
        </Box>
        <Button type="submit" variant="contained" fullWidth>
          Submit
        </Button>
      </form>
    </Container>
  );
};

export default UserFormComponent;
